import { ActionIcon, Box, Tooltip, useMantineTheme } from '@mantine/core';
import { captureException } from '@sentry/react';
import { IconGavel, IconScale } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { isDefined } from 'remeda';

import debtCollectorIcon from '../../../shared/components/InvoiceActionsDropdown/ChooseThirdPartyTypeForm/debt-collector.svg';
import type { KanbanInvoice } from '../api/use-load-invoice-column';

interface ThirdPartyIconProps {
  invoice: KanbanInvoice;
}

export const ThirdpartyIcon = ({ invoice }: ThirdPartyIconProps) => {
  const theme = useMantineTheme();

  if (!isDefined(invoice.thirdPartyCase)) return null;

  const { type, description, date } = invoice.thirdPartyCase;

  const ICON_PROPS = { size: 18, stroke: 1.3, color: theme.colors.gray[7] };

  const icon = (() => {
    switch (type) {
      case 'lawyer':
        return <IconGavel style={{ width: '70%', height: '70%' }} {...ICON_PROPS} />;
      case 'bailiff':
        return <IconScale style={{ width: '70%', height: '70%' }} {...ICON_PROPS} />;
      case 'debt_collector':
        return <img width="70%" height="70%" src={debtCollectorIcon} alt="Debt collector" />;
      default:
        captureException('Encountered unknown third party case type', { extra: { invoice } });
        return null;
    }
  })();

  return (
    <Tooltip
      withArrow
      label={
        <>
          {description} {dayjs(date).format('L')}
        </>
      }
    >
      <Box>
        <ActionIcon size="sm" variant="default" style={{ pointerEvents: 'none' }}>
          {icon}
        </ActionIcon>
      </Box>
    </Tooltip>
  );
};
